import React from "react";
import { Controls, FormGroup, IFormStyles, useFormStyles } from "../.";
import { FormGroupProps } from "../misc/formGroup";
import { useField } from "formik";

export interface FormCheckboxProps extends Controls.ControlCheckboxProps {
    isLoading?: boolean | undefined;
    label?: string | undefined;
    isOptional?: boolean | undefined;
    tooltip?: string | undefined;
}

const ComponentProps = (
    props: FormCheckboxProps
): Controls.ControlCheckboxProps => {
    const componentProps = Object.assign({}, props);
    delete componentProps.isLoading;
    delete componentProps.label;
    delete componentProps.isOptional;
    delete componentProps.tooltip;

    return componentProps;
};

const GroupProps = (props: FormCheckboxProps): FormGroupProps => {
    const groupProps: FormGroupProps = {
        controlStyles: props.controlStyles,
        isLoading: props.isLoading,
        disabled: props.disabled,
        groupType: "check",

        label: props.label,
        isOptional: props.isOptional,
        tooltip: props.tooltip,
    };

    return groupProps;
};

export const FormCheckbox: React.FC<Controls.ControlCheckboxProps> = (
    props
) => {
    const [field] = useField({ name: props.name, type: "checkbox" });
    const styles: IFormStyles = useFormStyles();

    return (
        <FormGroup {...GroupProps(props)}>
            <Controls.ControlCheckbox
                {...field}
                {...ComponentProps(props)}
                controlStyles={styles.control}
            />
        </FormGroup>
    );
};
